import { render, staticRenderFns } from "./Userlogs.vue?vue&type=template&id=b70779b8&scoped=true&"
import script from "./Userlogs.vue?vue&type=script&lang=js&"
export * from "./Userlogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70779b8",
  null
  
)

export default component.exports